function initBannerClockSubscribe($section) {
  const $newsletterForm = $section.querySelector('.farm-newsletter-form');
  if ($newsletterForm) {
    const $inputs = $newsletterForm.querySelectorAll('input');
    $inputs.forEach(($input) => {
      $input.addEventListener('change', () => {
        let hasValue = false;
        $inputs.forEach(($inputElement) => {
          if (hasValue) {
            return;
          }
          hasValue = Boolean($inputElement.value.length);
        });
        if (hasValue) {
          $section.classList.add('no-empty');
          return;
        }
        $section.classList.remove('no-empty');
      });
    });
  }
}

document.querySelectorAll('.banner-clock-subscribe').forEach(initBannerClockSubscribe);
